import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import styles from "./OutletBanner.module.scss";
import desktopHeroImg from "../../../../assets/images/pages/home/hero-section/desktop.png";
import tabletHeroImg from "../../../../assets/images/pages/home/hero-section/mobile.png";
import mobileHeroImg from "../../../../assets/images/pages/home/hero-section/tablet.png";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const ChevronLeftIcon = FiChevronLeft as any;
const ChevronRightIcon = FiChevronRight as any;

const OutletBanner: React.FC = () => {
  const translations = useSelector(
    (state: RootState) => state.translations.data
  );

  const handleScrollToProducts = (
    e: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>
  ) => {
    if ("key" in e && e.key !== "Enter" && e.key !== " ") {
      return;
    }
    e.preventDefault();
    const productsSection = document.getElementById("products-section");
    if (!productsSection) {
      return;
    }
    productsSection.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className={styles.outletBanner} aria-label={translations?.welcome || "Xoş gəlmisiniz"}>
      <div className="container">
        <div className={styles.heroCard}>
          {/* Responsive Picture serving desktop, tablet and mobile images */}
          <picture className={styles.heroPicture}>
            <source media="(min-width: 1024px)" srcSet={desktopHeroImg} />
            <source media="(min-width: 640px)" srcSet={tabletHeroImg} />
            <img
              src={mobileHeroImg}
              alt={translations?.welcome || "Xoş gəlmisiniz"}
              className={styles.heroBgImg}
              loading="eager"
            />
          </picture>

          {/* Desktop slider navigation arrows */}
          <button
            type="button"
            className={`${styles.sliderArrow} ${styles.sliderArrowPrev}`}
            aria-label={translations?.previous || "Əvvəlki slayd"}
            tabIndex={0}
          >
            <ChevronLeftIcon size={20} />
          </button>
          <button
            type="button"
            className={`${styles.sliderArrow} ${styles.sliderArrowNext}`}
            aria-label={translations?.next || "Növbəti slayd"}
            tabIndex={0}
          >
            <ChevronRightIcon size={20} />
          </button>

          {/* Text and Action Buttons Overlay */}
          <div className={styles.heroContentOverlay}>
            <div className={styles.heroPretitle}>
              <span className={styles.dash} />
              <span>
                {translations?.quality_products_choice ||
                  "Keyfiyyətli məhsullar, daha geniş seçim"}
              </span>
            </div>

            <h1 className={styles.heroTitle}>
              {translations?.welcome || "Xoş gəlmisiniz"}
            </h1>

            <p className={styles.heroDescription}>
              {translations?.benefit_our_services ||
                "Bizim xidmətlərimizdən yararlanın."}
            </p>

            <div className={styles.heroActions}>
              <a
                href="#products-section"
                onClick={handleScrollToProducts}
                onKeyDown={handleScrollToProducts}
                className={styles.primaryHeroBtn}
                aria-label={translations?.products || "Məhsullar"}
                tabIndex={0}
              >
                <span>{translations?.products || "Məhsullar"}</span>
              </a>

              <Link
                to="/products"
                className={styles.secondaryHeroBtn}
                aria-label={translations?.show_more || "Daha çox"}
                tabIndex={0}
              >
                <span>{translations?.show_more || "Daha çox"}</span>
                <span className={styles.arrowIcon}>↗</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OutletBanner;
